<form class="tour-quantities" id="quant-scroll" #quantitiesForm="ngForm"  *ngIf="feedstock && feedstock.quantities">
  <div class="flex-container" *ngIf="materialTypeIsAnimal()">
    <!--quantity quantity type dropdown-->
    <div class="flex-box">
      <mat-form-field>
        <mat-label>{{'PROJECT.FEEDSTOCK.QUANTITY.TYPE' | anessaTranslation: trigger}}</mat-label>
        <mat-select id="feedstock-quantities-quantity-type_select"
                    placeholder="choose"
                    disableOptionCentering
                    [(ngModel)]="feedstock.quantities.isAnimal"
                    (ngModelChange)="changesMadeNotifier.emit()"
                    name="quantity-type">
          <mat-option [value]="true">{{'PROJECT.FEEDSTOCK.QUANTITY.ANIMAL_MODEL' | anessaTranslation: trigger}}</mat-option>
          <mat-option [value]="false">{{'PROJECT.FEEDSTOCK.QUANTITY.QUANT_MODEL' | anessaTranslation: trigger}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="flex-container section-spacing">
    <!--if material type is general-->
    <ng-container *ngIf="!feedstock.quantities.isAnimal">
      <!--unit value for feedstock quantity mass-->
      <div class="section-item">
        <app-unit-value
          name="feedstock-mass-uv"
          units="Mass"
          label="{{'PROJECT.FEEDSTOCK.QUANTITY.MASS' | anessaTranslation: trigger}}"
          flexStyle="column"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.quantities.mass"
          (ngModelChange)="onUnitValueChanged()"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
      <div style="align-self: center;" anessaTranslation="PROJECT.COMMON.PER"></div>
    </ng-container>
    <!--if material type is animal-->
    <ng-container *ngIf="feedstock.quantities.isAnimal">
      <!--unit value for feedstock quantity number of animals-->
      <div class="section-item">
        <app-unit-value
          name="feedstock-num-animals-uv"
          units="Count"
          label="{{'PROJECT.FEEDSTOCK.QUANTITY.NUM_ANIMAL' | anessaTranslation: trigger}}"
          flexStyle="column"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.quantities.numAnimals"
          (ngModelChange)="onUnitValueChanged()"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
      <!--unit value for feedstock quantity waste production per animal-->
      <div class="section-item">
        <app-unit-value
          name="feedstock-manure production-uv"
          units="Mass"
          label="{{'PROJECT.FEEDSTOCK.QUANTITY.WASTE_PROD' | anessaTranslation: trigger}}"
          flexStyle="column"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.quantities.manureProduction"
          (ngModelChange)="onUnitValueChanged()"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
    </ng-container>
    <!--unit value for feedstock quantity period-->
    <div class="section-item">
      <app-unit-value
        name="feedstock-period-uv"
        units="Period"
        label="{{'PROJECT.FEEDSTOCK.QUANTITY.PERIOD' | anessaTranslation: trigger}}"
        flexStyle="column"
        [styleWhiteBoxes]="true"
        [setGreaterThanValue]="0"
        [(ngModel)]="feedstock.quantities.period"
        (ngModelChange)="onUnitValueChanged()"
        [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
        [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
      ></app-unit-value>
    </div>
  </div>
</form>
